
import './App.css';
import { Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";


import axios from 'axios';
import { lazy, Suspense, useEffect, useState, useRef } from 'react';
import Outh from './component/aouth/aouth/aouth';


import { useSelector, useDispatch } from "react-redux";

import { checkedSessionAction } from './redux/reducer/getCheckedCompanySession/action/action';


import YandexMetric from './component/utilt/bootstrapAlert/yandexMetrica';


import sockets, { connectIfNeeded } from './socket/socket';
import usePresenceSocket from './socket/usePresenceSocket';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import {
  Box,
  SkeletonCircle,
  SkeletonText,
  Skeleton
} from '@chakra-ui/react';
import { setNavigate } from './api/navigationService';
import { ConfigProvider, theme as antdTheme } from "antd";
import { popupLayers } from "./popupLayers";
import dayjs from "dayjs";


import FirstVisit from './component/page/firstVisit/firstVisit';


import PushNotificationSubscriber from './component/PushNotificationSubscriber/PushNotificationSubscriber';


import ProtectedRoutes from './component/page/protectedRoutes/protectedRoutes';


import MaintenanceWatcher from './component/page/MaintenanceWatcher/MaintenanceWatcher';


import { preloadOtherMenuIcons } from './component/nav/mobIcons/otherMenuIconPreload';
import { setupAxiosDeviceId } from './component/utilt/deviceId';
import ruRU from "antd/locale/ru_RU";
import "dayjs/locale/ru";


import GlobalProductTour from './component/global/GlobalProductTour/GlobalProductTour';
import { clearAllNavV3Caches } from './redux/reducer/navFlags/navFlagsHelpers';
import PageV3Switch from './component/ui/v3/PageV3Switch';


// Разделы сервиса грузятся отдельными чанками по мере перехода: лендинг (/login, aouth.jsx)
// и глобальные компоненты остаются в основной сборке, остальное не скачивается до входа.
// Свой Suspense у каждого раздела, чтобы при загрузке вложенной страницы не пропадало меню.
function PageFallback() {
  return <div className="app-page-fallback" aria-busy="true" />;
}

// При выкатке старые чанки с сервера удаляются, а вместо отсутствующего файла сервер отдаёт
// index.html. Вкладка, открытая до выкатки, при переходе в раздел не может загрузить его чанк,
// и раздел падает. Один раз перезагружаем страницу за свежим index.html; если чанк не грузится
// и после перезагрузки (меньше минуты назад уже перезагружали), ошибка уходит дальше.
const CHUNK_RELOAD_KEY = "uprosti:chunkReloadAt";
const CHUNK_RELOAD_INTERVAL_MS = 60 * 1000;

function isChunkLoadError(error) {
  return error?.name === "ChunkLoadError" || /Loading (CSS )?chunk \S+ failed/i.test(String(error?.message || ""));
}

function markChunkReload() {
  try {
    const lastReloadAt = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
    if (Date.now() - lastReloadAt < CHUNK_RELOAD_INTERVAL_MS) return false;
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
    return true;
  } catch (_error) {
    // Без sessionStorage не перезагружаем, чтобы не уйти в цикл перезагрузок.
    return false;
  }
}

function loadPageChunk(loader) {
  return loader().catch((error) => {
    if (!isChunkLoadError(error) || !markChunkReload()) throw error;
    window.location.reload();
    // Пока страница перезагружается, раздел показывает заглушку загрузки.
    return new Promise(() => {});
  });
}

function lazyPage(loader) {
  const Page = lazy(() => loadPageChunk(loader));
  function LazyPage(props) {
    return (
      <Suspense fallback={<PageFallback />}>
        <Page {...props} />
      </Suspense>
    );
  }
  return LazyPage;
}

const AddNewCompany = lazyPage(() => import("./component/page/addCompany/addCompany"));
const CardUser = lazyPage(() => import("./component/page/settingsUser/settingsPage/datecellery/datecellery"));
const SettingNav = lazyPage(() => import("./component/page/settingsUser/settingNav/setttingNav"));
const AddNewUser = lazyPage(() => import("./component/page/settingsUser/addNewUser/addNewUser"));
const Mydata = lazyPage(() => import("./component/page/settingsUser/settingsPage/mydata/mydata"));
const ChangeApi = lazyPage(() => import("./component/page/chaneApi/chanegApi"));
const EditCompanyOption = lazyPage(() => import("./component/page/addCompany/editCompany/editCompanyOptions/editCompanyOptions"));
const AdminLogin = lazyPage(() => import("./component/aouth/admin/adminLogin"));
const AdmiNav = lazyPage(() => import("./component/page/adminPage/adminNav/adminNav"));
const AllCompany = lazyPage(() => import("./component/page/adminPage/allCompany/allCompany"));
const Allusers = lazyPage(() => import("./component/page/adminPage/allUsers/allUsers"));
const AllAdmin = lazyPage(() => import("./component/page/adminPage/addNewAdmin/addNewAdmin"));
const Wildberries = lazyPage(() => import("./component/page/wildberries/wildberries"));
const Ozon = lazyPage(() => import("./component/page/ozon/ozon"));
const TaskMeneger = lazyPage(() => import("./component/page/taskManager/taskmeneger"));
// Корень кабинета: выбирает старое или новое меню (component/navV3/ShellSwitch.jsx).
const ShellSwitch = lazyPage(() => import("./component/navV3/ShellSwitch"));
const CreatTask = lazyPage(() => import("./component/page/taskManager/addTask/addTask"));
const GetcurrentTask = lazyPage(() => import("./component/page/taskManager/getCurrentTask/getCurrentTask"));
const EditChild = lazyPage(() => import("./component/page/taskManager/editChild/editChild"));
const NoPage = lazyPage(() => import("./component/page/noPage/noPage"));
const InDevelopingPage = lazyPage(() => import("./component/page/inDevelopingPage/inDevelopingPage"));
const Home = lazyPage(() => import("./component/page/home/home"));
const ChatContainer = lazyPage(() => import("./component/page/chat/chatContainer/chatContainer"));
const ChatNavFilter = lazyPage(() => import("./component/page/chat/chatNavFilter/chatNavFilter"));
const PublicChat = lazyPage(() => import("./component/page/chat/publicChat/publicChat"));
const Conversations = lazyPage(() => import("./component/page/chat/conversationsChat/conversations"));
const PrivateChat = lazyPage(() => import("./component/page/chat/privateChat/privateChat"));
const OtherNavItems = lazyPage(() => import("./component/nav/otherNavItems/otherNavItems"));
const AdmiNavigation = lazyPage(() => import("./component/page/adminPage/AdmiNavigation/AdmiNavigation"));
const MyPageAdmin = lazyPage(() => import("./component/page/adminPage/myPageAdmin/myPageAdmin"));
const GraphCompany = lazyPage(() => import("./component/page/settingsUser/settingsPage/graphCompany/graphCompany"));
const QRScannerOuth = lazyPage(() => import("./component/aouth/qrScannerOuth/qrsCannerOuth"));
const AppLication = lazyPage(() => import("./component/page/application/appLication/appLication"));
const WBtable = lazyPage(() => import("./component/page/wildberries/wbtable/wbTable"));
const WBunit = lazyPage(() => import("./component/page/wildberries/wbunit/wbunit"));
const Payment = lazyPage(() => import("./component/page/payment/payment"));
const PromoAdminPanel = lazyPage(() => import("./component/page/adminPage/promoAdminPanel/PromoAdminPanel"));
const DashboardPayment = lazyPage(() => import("./component/page/adminPage/DashboardPayment/dashboardPayment"));
const TestXSS = lazyPage(() => import("./component/page/test/TestXSS/TestXSS"));
const DraggableTable = lazyPage(() => import("./component/page/ozoEdit/ozonTable/ozontable"));
const OzonUnit = lazyPage(() => import("./component/page/ozoEdit/ozonUnit/ozonUnit"));
const OzonPnl = lazyPage(() => import("./component/page/ozoEdit/ozonPnl/OzonPnl"));
const WbPnl = lazyPage(() => import("./component/page/wildberries/wbPnl/WbPnl"));
const OzonQueueDashboard = lazyPage(() => import("./component/page/adminPage/ozonQueueDashboard/ozonQueueDashboard"));
const PnlQueueDashboard = lazyPage(() => import("./component/page/adminPage/pnlQueueDashboard/PnlQueueDashboard"));
const WbQueueDashboard = lazyPage(() => import("./component/page/adminPage/WbQueueDashboard/WbQueueDashboard"));
const Maps = lazyPage(() => import("./component/page/adminPage/maps/maps"));
const SystemMetricsLiveCard = lazyPage(() => import("./component/page/adminPage/SystemMetricsLiveCard/SystemMetricsLiveCard"));
const QueueAdminTask = lazyPage(() => import("./component/page/adminPage/QueueAdminTask/queueAdmin"));
const TutorialVideoAdmin = lazyPage(() => import("./component/page/adminPage/tutorialVideoAdmin/TutorialVideoAdmin"));
const DbAdmin = lazyPage(() => import("./component/page/adminPage/DbAdmin/DbAdmin"));
const BackupsPage = lazyPage(() => import("./component/page/adminPage/backupsPage/BackupsPage"));
const VideoChatModal = lazyPage(() => import("./component/page/videoRoom/VideoRoom"));
const NewsPage = lazyPage(() => import("./component/page/newsPage/NewsPage"));
const AdminComposer = lazyPage(() => import("./component/page/adminPage/newsAdmin/AdminComposer"));
const AdminNewsManager = lazyPage(() => import("./component/page/adminPage/AdminNewsManager/AdminNewsManager"));
const MarketplaceAiRecommendations = lazyPage(() => import("./component/page/ozoEdit/marketplaceAIRecommendations/marketplaceAiRecommendations"));
const WbCostsPage = lazyPage(() => import("./component/page/marketplaceCosts/WbCostsPage"));
const OzonCostsPage = lazyPage(() => import("./component/page/marketplaceCosts/OzonCostsPage"));
const UnitPlanningCalculator = lazyPage(() => import("./component/page/unitPlanning/UnitPlanningCalculator"));
const PriceCalcWB = lazyPage(() => import("./component/page/priceCalc/PriceCalcWB"));
const PriceCalcOzon = lazyPage(() => import("./component/page/priceCalc/PriceCalcOzon"));
const ProfitWB = lazyPage(() => import("./component/page/profit/ProfitWB"));
const ProfitOzon = lazyPage(() => import("./component/page/profit/ProfitOzon"));
const ProfitItemsWB = lazyPage(() => import("./component/page/profitItems/ProfitItemsWB"));
const ProfitItemsOzon = lazyPage(() => import("./component/page/profitItems/ProfitItemsOzon"));
// Прежний калькулятор — запасной для «Расчёта цены» (PageV3Switch даёт странице только себя, без свойств).
const UnitPlanningWB = () => <UnitPlanningCalculator marketplace="wb" />;
const UnitPlanningOzon = () => <UnitPlanningCalculator marketplace="ozon" />;
// Новая «Реклама» (page/ads); запасной прежней страницы нет (решение Operus 28.10).
const AdsWB = lazyPage(() => import("./component/page/ads/AdsWB"));
const AdsOzon = lazyPage(() => import("./component/page/ads/AdsOzon"));
const SupplyWB = lazyPage(() => import("./component/page/supply/SupplyWB"));
const SupplyOzon = lazyPage(() => import("./component/page/supply/SupplyOzon"));
const MarketplaceAiRecommendationsWB = lazyPage(() => import("./component/page/wildberries/MarketplaceAiRecommendationsWB/MarketplaceAiRecommendationsWB"));
// Новые «Советы» (cabinet-redesign); прежние страницы выше остаются запасными.
const TipsWB = lazyPage(() => import("./component/page/tips/TipsWB"));
const TipsOzon = lazyPage(() => import("./component/page/tips/TipsOzon"));
// Новые «Заказы и остатки»; прежние таблицы WBtable и DraggableTable остаются запасными.
const OrdersWB = lazyPage(() => import("./component/page/goods/OrdersWB"));
const OrdersOzon = lazyPage(() => import("./component/page/goods/OrdersOzon"));
const PricesDiscountsPage = lazyPage(() => import("./component/page/marketplaceDiscounts/PricesDiscountsPage"));
const TaskTeams = lazyPage(() => import("./component/page/settingsUser/TaskTeams/TaskTeams"));
const ReferralPage = lazyPage(() => import("./component/page/referral/ReferralPage"));
const AdminReferralPage = lazyPage(() => import("./component/page/adminPage/AdminReferralPage/AdminReferralPage"));
const AdminTariffsPage = lazyPage(() => import("./component/page/adminPage/AdminTariffsPage/AdminTariffsPage"));
const ReviewsPage = lazyPage(() => import("./component/page/reviews/ReviewsPage"));
const AiCardPage = lazyPage(() => import("./component/page/aiCard/AiCardPage"));
const Statistic = lazyPage(() => import("./component/page/statistic/statistic1").then((m) => ({ default: m.Statistic })));
const EmployeeTemplateComand = lazyPage(() => import("./component/page/settingsUser/employee template/employeeTemplate").then((m) => ({ default: m.EmployeeTemplateComand })));

// Незалогиненного посетителя (в том числе рекламный заход на «/?utm…») сразу ведём на лендинг,
// не загружая меню сервиса: раньше на /login уводил запрос внутри NavBarCont, уже после загрузки
// всех его чанков. Параметры адреса сохраняем — по ним лендинг выбирает сценарий.
let knownSignedIn = false;

function AuthGate({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState(knownSignedIn ? "in" : "checking");

  useEffect(() => {
    if (knownSignedIn) return undefined;
    let cancelled = false;
    axios
      .get("/registration/v2/api", { withCredentials: true })
      .then(({ data }) => {
        const signedIn = data?.authorization === true && Boolean(data?.data?._id);
        knownSignedIn = signedIn;
        if (!cancelled) setStatus(signedIn ? "in" : "out");
      })
      .catch(() => {
        if (!cancelled) setStatus("out");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === "checking") return <PageFallback />;
  if (status === "out") return <Navigate to={`/login${location.search}`} replace />;
  return children;
}

// Старый адрес страницы (например, с опечаткой): закладки, письма и уведомления
// попадают на новый, вместе с параметрами ссылки.
function MovedTo({ to }) {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}${location.hash}`} replace />;
}

axios.defaults.withCredentials = true;
setupAxiosDeviceId(axios);


dayjs.locale("ru");
const socket = sockets;

function App() {
  const dispatch = useDispatch()
  let getCompanyID = useSelector(compID => compID.checkedSessionReducer)

  //проверить мастер-авторизацию
  // let[data, error, loading,getData]= ByAxios("/auth/login/api")

  let getmyinfo = useSelector(compID => compID.getMayInfoReducer)
  const [roomJoined, setRoomJoined] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const myinfos = useSelector(data => data.getMyImageReducer)
  const getmyinforeducer = useSelector(compID => compID.getMayInfoReducer);

  const [isLoading, setIsLoading] = useState(true); // состояние загрузки
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    const handleLoad = () => setIsLoading(false);

    // Проверяем состояние загрузки документа
    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("DOMContentLoaded", handleLoad);
      window.addEventListener("load", handleLoad);
    }

    return () => {
      window.removeEventListener("DOMContentLoaded", handleLoad);
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  const isDark = useSelector(
    (state) => state.ToggleDarkModeReducer?.chekced
  );


  // Единая система online/offline.
  // Этот хук сам:
  // - отправляет presence:join при входе/переподключении;
  // - обновляет Redux onlineUserIds через presence:update;
  // - отправляет presence:leave при закрытии вкладки;
  // - сохраняет совместимость со старым событием online.
  usePresenceSocket({
    user: getmyinfo?.myinfo,
    companyId: getCompanyID?.checkedSession,
  });

  useEffect(() => {
    const user = getmyinfo?.myinfo;

    const hasUser =
      user &&
      typeof user === "object" &&
      !Array.isArray(user) &&
      user._id;

    if (!hasUser) return;

    const updateSocketUser = () => {
      socket.emit("pushmyid", user._id);
      socket.emit("updateMydataOnlineTrueForServer");

      // добавить это
      socket.emit("activeSessions:refreshForUser", {}, () => { });

      if (getCompanyID?.checkedSession) {
        socket.emit("joinRoom", getCompanyID.checkedSession);
        socket.emit("getNotifyEmit");
      }

      console.log("Socket обновлён для пользователя:", user._id);
    };

    if (socket.connected) {
      updateSocketUser();
    } else {
      socket.once("connect", updateSocketUser);

      if (typeof socket.connect === "function") {
        socket.connect();
      }
    }

    return () => {
      socket.off("connect", updateSocketUser);
    };
  }, [getmyinfo?.myinfo?._id, getCompanyID?.checkedSession]);

  // Глобальный listener для завершения сеанса с другого устройства.
  // ВАЖНО: он должен быть в App.jsx, а не только внутри ActiveSessionsCard,
  // потому что пользователь может находиться на любой странице.
  useEffect(() => {
    const handleForceLogout = (payload = {}) => {
      console.warn("Сеанс завершён с другого устройства:", payload);

      try {
        sessionStorage.clear();
        localStorage.removeItem("token");
      } catch (error) {
        console.error("Не удалось очистить storage после forceLogout:", error);
      }

      // Выбор меню хранится для каждого человека: следующий в этом браузере не получит чужое меню.
      clearAllNavV3Caches();

      if (window.location.pathname !== "/login") {
        navigate("/login", { replace: true });
      }
    };

    socket.on("activeSessions:forceLogout", handleForceLogout);

    // запасное имя события, если позже захочешь использовать короткое событие
    socket.on("session:forceLogout", handleForceLogout);

    return () => {
      socket.off("activeSessions:forceLogout", handleForceLogout);
      socket.off("session:forceLogout", handleForceLogout);
    };
  }, [navigate]);


  // Оставляем только бизнес-логику компании/комнаты.
  // Online/offline больше НЕ обновляем через axios.patch('/updateOnlineOffline/api').
  useEffect(() => {
    if (
      !Array.isArray(getmyinfo?.myinfo) &&
      typeof getmyinfo?.myinfo === 'object' &&
      getmyinfo?.myinfo !== null
    ) {
      dispatch(checkedSessionAction('/getCheckedCompanySession'));
    }
  }, [getmyinfo?.myinfo, dispatch]);

  useEffect(() => {
    if (getCompanyID?.checkedSession && !roomJoined) {
      socket.emit('joinRoom', getCompanyID.checkedSession);
      socket.emit('getNotifyEmit');
      setRoomJoined(true);
    }
  }, [getCompanyID?.checkedSession, roomJoined]);

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: (registration) => {
        // Показ уведомления о доступном обновлении
        showUpdateNotification(registration);
      },
      onSuccess: () => {
        console.log('Приложение кэшировано для оффлайн-использования.');
      },
    });

  }, []);

  // Иконки меню (около 2 МБ PNG) нужны только в сервисе: на лендинге не подгружаем.
  const signedInUserId = getmyinfo?.myinfo?._id;
  useEffect(() => {
    if (signedInUserId) preloadOtherMenuIcons();
  }, [signedInUserId]);

  function showUpdateNotification(registration) {
    const notification = new Notification("Доступно новое обновление!", {
      body: "Нажмите для обновления.",
      icon: "/android-chrome-512x512.png", // Путь к изображению
    });

    notification.onclick = () => {
      // Обновить приложение при клике на уведомление
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    };
  }


  // return ( <TestXSS />)

  // Если страница загружается, показываем индикатор загрузки
  if (isLoading) {
    return (
      <Box padding='6' boxShadow='lg' bg='white' minHeight="100dvh">
        <SkeletonCircle size='10' />
        <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='2' />
        <Skeleton height='50px' mt='4' noOfLines={4} spacing='4' skeletonHeight='2' />
        <Skeleton height='50px' mt='4' noOfLines={4} spacing='4' skeletonHeight='2' />
        <Skeleton height='50px' mt='4' noOfLines={4} spacing='4' skeletonHeight='2' />
        <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='2' />
        <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='2' />
        <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='2' />
        <Skeleton height='50px' mt='4' noOfLines={4} spacing='4' skeletonHeight='2' />
        <Skeleton height='50px' mt='4' noOfLines={4} spacing='4' skeletonHeight='2' />
        <Skeleton height='50px' mt='4' noOfLines={4} spacing='4' skeletonHeight='2' />
      </Box>
    );
  }

  const data = {
    search: [
      {
        warehouse_id: 21705001607000,
        warehouse_type: "WAREHOUSE_TYPE_CROSS_DOCK",
        coordinates: { latitude: 56.103758, longitude: 93.070763 },
        address: "Россия, 660111, край Красноярский, г. Красноярск, ул. Пограничников, д. 9И",
        name: "КРАСНОЯРСК_МРФЦ_Кроссдокинг",
      },
      // можешь добавить ещё ...
    ],
  };


  return (
    <ConfigProvider
      theme={{
        algorithm: isDark
          ? antdTheme.darkAlgorithm
          : antdTheme.defaultAlgorithm,
        token: {
          fontFamily:
            'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          fontSize: 16,
          fontWeightStrong: 900,

          colorPrimary: "#5B7CFA",
          borderRadius: 14,
          colorBgContainer: isDark ? "#151B23" : "#FFFFFF",
          colorText: isDark ? "#F5F7FA" : "#111827",
          colorBorder: isDark ? "rgba(255,255,255,0.08)" : "#E3E8F2",
        },
        components: popupLayers,
      }}
      locale={ruRU}
    >
      <div>

        <MaintenanceWatcher />
        < ProtectedRoutes />
        <PushNotificationSubscriber />
        <FirstVisit />
        <YandexMetric />

        <GlobalProductTour />
        <Routes>
          <Route path="/" element={<AuthGate><ShellSwitch /></AuthGate>}>
            <Route element={<ProtectedRoutes />}>
              <Route index element={<Home />} />
              {/* <Route path="wildberries" element={<Wildberries />} /> */}
              <Route path="wildberries" element={<Wildberries />} >
                <Route path="prices-discounts" element={<PricesDiscountsPage marketplace="wb" />} />
                <Route path="wbDashboard" element={<PageV3Switch name="orders-wb" NewPage={OrdersWB} OldPage={WBtable} />} />
                <Route path="wbDashbord" element={<MovedTo to="/wildberries/wbDashboard" />} />
                <Route path="costs" element={<WbCostsPage />} />
                <Route path="advertising" element={<AdsWB />} />
                <Route path="supply" element={<SupplyWB />} />
                <Route path="wbUnit" element={<PageV3Switch name="profit-items-wb" NewPage={ProfitItemsWB} OldPage={WBunit} />} />
                <Route path="wnubit" element={<MovedTo to="/wildberries/wbUnit" />} />
                <Route path="pnl" element={<PageV3Switch name="profit-wb" NewPage={ProfitWB} OldPage={WbPnl} />} />
                <Route path="planUnit" element={<PageV3Switch name="calc-wb" NewPage={PriceCalcWB} OldPage={UnitPlanningWB} />} />
                <Route path="wbAI" element={<PageV3Switch name="tips-wb" NewPage={TipsWB} OldPage={MarketplaceAiRecommendationsWB} />} />
              </Route>


              <Route path="ozon" element={<Ozon />} >
                <Route path="prices-discounts" element={<PricesDiscountsPage marketplace="ozon" />} />
                <Route path="ozonDashboard" element={<PageV3Switch name="orders-ozon" NewPage={OrdersOzon} OldPage={DraggableTable} />} />
                <Route path="ozonDashbord" element={<MovedTo to="/ozon/ozonDashboard" />} />
                <Route path="costs" element={<OzonCostsPage />} />
                <Route path="advertising" element={<AdsOzon />} />
                <Route path="supply" element={<SupplyOzon />} />
                <Route path="ozonUnit" element={<PageV3Switch name="profit-items-ozon" NewPage={ProfitItemsOzon} OldPage={OzonUnit} />} />
                <Route path="pnl" element={<PageV3Switch name="profit-ozon" NewPage={ProfitOzon} OldPage={OzonPnl} />} />
                <Route path="planUnit" element={<PageV3Switch name="calc-ozon" NewPage={PriceCalcOzon} OldPage={UnitPlanningOzon} />} />
                <Route path="ozonAI" element={<PageV3Switch name="tips-ozon" NewPage={TipsOzon} OldPage={MarketplaceAiRecommendations} />} />
              </Route>

              <Route path="videCall" element={<VideoChatModal meName={getmyinforeducer.myinfo.name || getmyinforeducer.myinfo.tel || getmyinforeducer.myinfo.email} defaultRoom="tech-support" />} />
              <Route path="task" element={<TaskMeneger />} />
              <Route path="reviews" element={<ReviewsPage />} />
              <Route path="ai-card" element={<AiCardPage />} />
              <Route path="referral" element={<ReferralPage />} />
              <Route path="creattask" element={<CreatTask />} />
              <Route path="othermenu" element={<OtherNavItems />} />
              <Route path="getCurrentTask/:id" element={<GetcurrentTask />} />
              <Route path="editChild/:id/:index" element={<EditChild />} />
              <Route path="changeApi" element={<ChangeApi />} />
              <Route path="payment" element={<Payment />} />
              <Route path="EditCompanyOption" element={<EditCompanyOption />} />
              <Route path="yandex" element={<InDevelopingPage />} />
              <Route path="forum" element={<InDevelopingPage />} />
              <Route path="application" element={<AppLication />} />
              <Route path='sellertnewuserpage' element={<CardUser />}></Route>
              <Route path='mydata' element={<Mydata />}></Route>
              <Route path="settings" element={<SettingNav />} >
                <Route path='AddNewUser' element={<AddNewUser />}></Route>
                <Route path='graphCompany' element={<GraphCompany />}></Route>
                {/* <Route path='employeeTemplate' element={<EmployeeTemplateComand />}></Route> */}
                <Route path='commands' element={<TaskTeams />}></Route>
              </Route>
              <Route path="chat" element={<ChatNavFilter />}>
                <Route index element={<Navigate to="private" replace />} />
                <Route path="public" element={<PublicChat />} />
                <Route path="conversations" element={<Conversations />} />
                <Route path="private" element={<PrivateChat />} />
              </Route>
              <Route path="addnewcompany" element={<AddNewCompany />} />
              <Route path="statistic" element={<Statistic />} />
            </Route>
          </Route>


          <Route path="/login" element={<Outh />} />
          <Route path="/QRScannerOuth" element={<QRScannerOuth />} />

          {/* <Route path="/registration" element={<Registration />} /> */}
          {/* admin */}


          <Route path="/adminPage" element={<AdmiNavigation />}>
            <Route path="ozon-queue" element={<OzonQueueDashboard />} />
            <Route path="ozon-pnl-queue" element={<PnlQueueDashboard />} />
            <Route path="wb-queue" element={<WbQueueDashboard />} />
            <Route path="systemMetric" element={<SystemMetricsLiveCard />} />
            <Route path="maps" element={<Maps data={data} onMarkerClick={(wh) => console.log("клик по складу:", wh)} />} />
            <Route path="allcompany" element={<AllCompany />} />
            <Route path="allusers" element={<Allusers />} />
            <Route path="alladmin" element={<AllAdmin />} />
            <Route path="myPageAdmin" element={<MyPageAdmin />} />
            <Route path="promocode" element={<PromoAdminPanel />} />
            <Route path="paymentList" element={<DashboardPayment />} />
            <Route path="wb-queue-task" element={<QueueAdminTask />} />
            <Route path="admin-tutorial" element={<TutorialVideoAdmin />} />
            <Route path="DbAdmin" element={<DbAdmin />} />
            <Route path="backups-page" element={<BackupsPage />} />
            <Route path="admin-compozer" element={<AdminNewsManager sockets={sockets} />} />
            <Route path="referrals" element={<AdminReferralPage />} />
            <Route path="tariffs" element={<AdminTariffsPage />} />
          </Route>
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="*" element={<NoPage />} />
        </Routes>

      </div>
    </ConfigProvider>

  );
}

export default App;

